<div class="control__wrapper control__wrapper--wide bg-light">
    <img class="control__img bg-style bg-style__icon border-light"
        ngSrc="{{ setIcon(control.elementVal.getValue()?.iconId) }}"
        width="72" height="72" alt="" />
    <h2 class="control__title bg-style bg-style__label">
        {{ subtitle(control.elementVal.getValue()?.txtId) }}</h2>
    <div class="control__content data-table">
        <div class="data-table__inner">
            <div class="data-table__column">
                <div class="data-table__title color-light bg-style">
                    {{ subtitle(1155) }}
                </div>
                <div *ngFor="let val of control.elementVal.getValue()?.params.rowsData; let key = index">
                    <div class="data-table__item"
                        [ngClass]="{ 'bg-grey': key % 2 !== 0 }">
                        <p class="color-basic">{{ key + 1 }}</p>
                    </div>
                </div>
            </div>
            <div class="data-table__column"
                *ngFor="let val of control.elementVal.getValue()?.params.colsDef; let key = index">
                <div class="data-table__title color-light bg-style"
                    [attr.data-testid]="'columnTitle-' + key">
                    {{ subtitle(val.idSubtitle) }}
                </div>
                <div class="data-table__item"
                    *ngFor="let value of control.elementVal.getValue()?.params.rowsData; let innerKey = index"
                    [ngClass]="{ 'bg-grey': innerKey % 2 !== 0 }">
                    <p class="color-basic"
                        [attr.data-testid]="'rowValue-' + key + '-' + innerKey">
                        {{ value[key] | format:val.type }}
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="control__arrows dataTable">
        <img ngSrc="/assets/img/icons/arrows.svg"
             width="40" height="40" alt="" />
    </div>
    <div class="control__group-btn">
        <button class="control__button bg-default bg-default__button"
            data-testid="goBackButton"
            (click)="control.hideControl()">
            <img class="control__button-img"
                ngSrc="/assets/img/zone_icons/back.svg"
                width="40" height="40" alt="" />
        </button>
    </div>
</div>
